module.exports = __webpack_public_path__ + "media/brands/steyr-946a2698.png";